'use client';

import type {
  GeneralLayout,
  Menu,
} from '@eliadmin/core/src/api/general/types/general-layout-types';
import {
  Accordion,
  AccordionContent,
  AccordionItem,
  AccordionTrigger,
} from '@eliadmin/core/src/components/ui/accordion';
import { cn } from '@eliadmin/core/src/utils/style-utils';
import { FiMapPin } from 'react-icons/fi';
import { HtmlDescription } from '../shared/html-description';
import { getSafeHref, isRelativeHref } from '@eliadmin/core/src/utils/url-utils';
import Link from '@eliadmin/core/src/components/link';
import { SocialIcons } from '@eliadmin/core/src/components/header/social-icons';
import Image from '@eliadmin/core/src/components/image/image-wrapped';
import { EliLogo } from '@eliadmin/core/src/components/footer/eli-logo';
import { useTranslations } from '@eliadmin/core/src/hooks/use-translations';

export const MobileFooterContent = ({
  generalLayout,
  footerMenu,
}: {
  generalLayout: GeneralLayout;
  footerMenu: Menu[];
}) => {
  return (
    <>
      <Accordion
        type="multiple"
        className="flex w-full flex-col items-start justify-start gap-8 sm:hidden"
      >
        <AccordionItem className="w-full border-none" value="kamenna-predajna">
          <AccordionTrigger className={cn('w-full', 'ea-mobile-footer-content__accordion-trigger')}>
            KAMENNÁ PREDAJŇA
          </AccordionTrigger>
          <AccordionContent className="flex w-full flex-col items-start justify-start gap-4">
            <div className="flex w-full items-center justify-start gap-1.5 text-base font-normal text-primary xl:text-lg">
              <FiMapPin size={20} /> {generalLayout.data.contact?.address},{' '}
              {generalLayout.data.contact?.city}
            </div>
            <HtmlDescription
              color="foreground"
              content={generalLayout.data.footer?.text}
              className="ea-contact__opening-hours w-full"
            />
          </AccordionContent>
        </AccordionItem>
        {footerMenu
          .filter(item => item.name !== 'Kategórie')
          .map((item, i) => {
            return (
              <AccordionItem key={i} value={item.name} className="w-full border-none">
                <AccordionTrigger
                  className={cn('w-full', 'ea-mobile-footer-content__accordion-trigger')}
                >
                  {item.name}
                </AccordionTrigger>
                <AccordionContent className="flex w-full flex-col items-start justify-start gap-1">
                  {item.fields?.map((field, i) => {
                    const Comp = field.path
                      ? isRelativeHref(getSafeHref(field.path))
                        ? Link
                        : 'a'
                      : 'span';

                    return (
                      <Comp
                        key={item.name}
                        href={field.path ? getSafeHref(field.path) : (undefined as any)}
                        className={cn(
                          'text-sm font-light hover:underline',
                          'ea-menu-footer__item-field',
                        )}
                      >
                        {field.name}
                      </Comp>
                    );
                  })}
                </AccordionContent>
              </AccordionItem>
            );
          })}
      </Accordion>
      <SocialIcons className={{ wrapper: 'flex sm:hidden' }} />
      <div className="flex items-center justify-start gap-4 sm:hidden">
        <Image src={'/images/stripe.svg'} width={164} height={52} alt="Stripe" />
        <Image src={'/images/sps.svg'} width={132} height={52} alt="Slovak Parcel Service (SPS)" />
      </div>
    </>
  );
};
